

























import { computed, defineComponent, ref } from "@vue/composition-api";
import { InputUserPublicDataSearch } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { getFeedTabs } from "@/lib/feedTabs";
import config from "@/config";
import BasePage from "@/components/BasePage";
import TabsHeader from "@/components/TabsHeader";
import CreatorsFilters from "./components/CreatorsFilters";
import CreatorsList from "./components/CreatorsList";
import CreatorsListTabs from "./components/CreatorsListTabs";
import usersAllController from "./controllers/usersAllController";
import usersLiveController from "./controllers/usersLiveController";
import usersOnlineController from "./controllers/usersOnlineController";
import usersSearchController from "./controllers/usersSearchController";
import { CreatorsTabsEnum } from "./types";

export default defineComponent({
  name: "PageCreatorsList",
  components: {
    CreatorsFilters,
    BasePage,
    TabsHeader,
    CreatorsList,
    CreatorsListTabs,
  },
  props: {
    tab: { type: String as () => CreatorsTabsEnum, default: CreatorsTabsEnum.ALL },
  },
  setup(props) {
    const loading = ref(false);
    const showFiltersCreatorModal = ref(false);
    const allowSearch = computed(() => config.featureSearchBar);
    const showTotal = computed(() => config.featureDiscoveryCreatorsCountInTabs);

    const searchData = ref<Partial<InputUserPublicDataSearch>>({});

    const searchMode = computed(() => {
      const { relevantTerm, tags, locations, languages } = searchData.value;
      return !!(relevantTerm || tags?.length || locations?.length || languages?.length);
    });

    const total = ref<Record<CreatorsTabsEnum, number>>({
      [CreatorsTabsEnum.ALL]: 0,
      [CreatorsTabsEnum.ONLINE]: 0,
      [CreatorsTabsEnum.LIVE]: 0,
    });

    const { authUser } = useAuthUser();
    const tabs = computed(() => getFeedTabs({ withHome: !!authUser.value }));

    const controller = computed(() => {
      if (searchMode.value) return usersSearchController;

      switch (props.tab) {
        case CreatorsTabsEnum.ONLINE:
          return usersOnlineController;
        case CreatorsTabsEnum.LIVE:
          return usersLiveController;
        case CreatorsTabsEnum.ALL:
          return usersAllController;

        default:
          return null;
      }
    });

    const updateTotal = (activeTab: CreatorsTabsEnum, totalRecords: number | undefined) => {
      if (totalRecords === undefined) return;
      total.value = { ...total.value, [activeTab]: totalRecords };
    };

    const getTotal = async () => {
      await Promise.all([
        providers.UserPublicDataProvider.search({
          data: { size: 1, role: "creator", disabled: false, discoveryOnly: true },
        }).then(r => (total.value[CreatorsTabsEnum.ALL] = r.totalRecords)),
        providers.UserPublicDataProvider.search({
          data: { size: 1, role: "creator", disabled: false, discoveryOnly: true, isOnline: true },
        }).then(r => (total.value[CreatorsTabsEnum.ONLINE] = r.totalRecords)),
        providers.UserPublicDataProvider.search({
          data: { size: 1, role: "creator", disabled: false, discoveryOnly: true, isLive: true },
        }).then(r => (total.value[CreatorsTabsEnum.LIVE] = r.totalRecords)),
      ]);
    };

    if (showTotal.value) {
      getTotal();
    }

    return {
      loading,
      allowSearch,
      searchMode,
      tabs,
      controller,
      total,
      showFiltersCreatorModal,
      showTotal,
      searchData,
      updateTotal,
    };
  },
});
